import { render, staticRenderFns } from "./MarketMarketHoliday.vue?vue&type=template&id=705967c5"
import script from "./MarketMarketHoliday.vue?vue&type=script&lang=js"
export * from "./MarketMarketHoliday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports